// Temporary here. After deprecation of legacy storages, all shared stuff will be inside the domain

import { I18NextPipe } from 'angular-i18next';
import { StorageType } from 'mbs-ui-shared';

export const amazonS3GlacierStorageTypes = [
  StorageType.AmazonS3,
  StorageType.AmazonS3Chinese,
  StorageType.AmazonGlacier,
  StorageType.AmazonGlacierChinese,
  StorageType.AmazonS3Eu
];

export const googleCloudStorageTypes = [StorageType.GoogleCloud, StorageType.Google];

export const googleDriveStorageTypes = [StorageType.GoogleDrive, StorageType.GoogleDriveOAuth];

export const ftpStorageTypes = [StorageType.FTP, StorageType.SFTP];

export const withRootFolderStorageTypes = [...ftpStorageTypes, ...googleDriveStorageTypes];

export const withContainerStorageTypes = [StorageType.Azure, StorageType.OpenStack];

// Storages where the MBS wizard can create an IAM role and send arnRoleOptions along with it
export const arnRoleStorageTypes = [StorageType.AmazonS3, StorageType.AmazonS3Eu, StorageType.Wasabi];

export const s3CompatibleStorages: StorageType[] = [
  StorageType.S3Compatible,
  StorageType.ScalityCloud,
  StorageType.Seeweb,
  StorageType.CenturyLink,
  StorageType.Cloudian,
  StorageType.DreamObjects,
  StorageType.Aruba,
  StorageType.ThinkOn
];

export const getBucketTypeName = (storageType: StorageType, i18N: I18NextPipe): string => {
  if (withRootFolderStorageTypes.includes(storageType)) {
    return i18N.transform('shared:common.rootFolder');
  }

  if (withContainerStorageTypes.includes(storageType)) {
    return i18N.transform('shared:common.container');
  }

  return i18N.transform('shared:common.bucket');
};
